export const SET_HUDDLE = "@meeting/setHuddle"
export const SET_HUDDLE_ACTIVE_PLAYERS = "@meeting/setHuddleActivePlayers"
export const FETCH_HUDDLE = "@meeting/fetchHuddle"